export default "__VITE_ASSET__ac0fbf7d__"